import { qs, qsa } from 'music';

/**
 * Does additional tweaking of the TOS modal as needed.
 */
function initializeTermsOfUseModal() {
  /**
   * Hide the header text in the terms-of-use partial. The `heading` attribute
   * in the `music-dialog-v3` custom element covers that part of the content already.
   */
  qs('.c-terms-title')?.setAttribute('hidden', true);

  const tosDialog = qs('.tos-dialog');
  const tosBtns = qsa('.tos-dialog__button');

  /**
   * Prevent dialog from closing on backdrop clicks.
   */
  tosDialog.addEventListener('sl-request-close', event => {
    if (event.detail.source === 'overlay') {
      event.preventDefault();
    }
  });

  /**
   * Set up the temporary button in the account-new view to open the TOS modal.
   */
  qs('.js-tos-dialog')?.addEventListener('click', () => {
    if (typeof tosDialog.show === 'function') {
      tosDialog.show();
    } else if (typeof tosDialog.showModal === 'function') {
      tosDialog.showModal();
    }
  });

  /**
   * Set up the buttons on the modal to close the modal on click.
   */
  tosBtns.forEach((el) => {
    el.addEventListener('click', () => {
      if (typeof tosDialog.hide === 'function') {
        tosDialog.hide();
      } else if (typeof tosDialog.closeModal === 'function') {
        tosDialog.closeModal();
      }
    });
  });

  /**
   * Prevent Disagree button from submitting form.
   */
  qs('.js-tos-disagree')?.addEventListener('click', (e) => {
    e.preventDefault;
  });

  const tosContent = tosDialog.shadowRoot.querySelector('[part="body"]') || tosDialog.shadowRoot.querySelector('.js-scrollbar-prevent-submit');

  // To create a gap and enable buttons just before the bottom of the container
  const scrollGap = 300;

  /*
    MAE-75707:
    Enable buttons by default. Don't disable buttons below 'md'
    breakpoint; The scrollable panel body is fully visible at
    that size and does not scroll, so the buttons should always
    be enabled.
  */
  const activate = (makeActive) => {
    tosBtns.forEach((btn) => {
      btn.disabled = !makeActive;
    });
  }

  const isScrolledToBottom = () => {
    if (tosContent.scrollHeight === 0) {
      return false;
    }
    return (tosContent.scrollTop + tosContent.clientHeight) >=
    (tosContent.scrollHeight - scrollGap);
  }

  const activateButtons = () => {
    activate(true);

    if (window.outerWidth >= 700) {
      console.log(isScrolledToBottom());
      activate(isScrolledToBottom());
    }

  };

  activateButtons();
  tosContent.addEventListener('scroll', activateButtons);
  window.addEventListener('resize', activateButtons);
}

export default initializeTermsOfUseModal;
